export { FadeInSlideUp } from './fade-in-slide-up'
